<template>
  <div class="wrapper withdraw-page">
    <!-- Header -->
    <Header />
    <!-- HeaderMenu -->
    <HeaderMenu />

    <div class="contents">
      <div class="layout">
        <div class="left">
          <div class="pc-only">
            <Sidebar />
          </div>
        </div>
        <div class="right">
          <div class="balance re">
            <h2>{{ $t("Possible withdrawal amount") }}</h2>
            <div class="total-amount"><span>10</span> AP</div>
            <ul class="list">
              <li>
                <h3>AP</h3>
                <div class="amount">
                  <span>90</span>
                </div>
              </li>
              <li>
                <h3>AP報酬</h3>
                <div class="amount">
                  <span>10</span>
                </div>
              </li>
            </ul>
          </div>
          <div class="form">
            <form>
              <div class="input-area">
                <label class="label" for="address">
                  <input
                    type="text"
                    name=""
                    id="address"
                    placeholder=" "
                    v-model="address"
                  />
                  <span class="group-label"
                    >AZEROのウォレットアドレスを入力してください。</span
                  >
                </label>
                <span class="circle" v-bind:class="{ done: hasAddress }">
                  <span class="bar"></span>
                </span>
              </div>
              <div class="txt">
                <p>※ 出金手数料は10％となります。</p>
              </div>
              <div class="all-amount">
                <p>{{ $t("Amount to be withdrawn") }}</p>
                <div class="number">
                  <span>{{ amountAp }}</span>
                  AP
                </div>
                <p class="notice">（手数料：10AP）</p>
              </div>
              <div class="btn">
                <button
                  type="button"
                  class="link-over"
                  id="send_btn"
                  v-on:click="show"
                  v-bind:disabled="!hasAddress"
                >
                  出金申請
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <!-- /.contents -->

    <modal
      name="sendModal"
      :resizable="true"
      :adaptive="true"
      :scrollable="true"
      width="90%"
      height="auto"
    >
      <div class="modal-box">
        <div class="modal-ttl">
          <p>100APを出金申請して<br />よろしいですか？</p>
        </div>
        <div class="btn">
          <button v-on:click="hide" type="button" class="link-over">
            完了する
          </button>
        </div>
      </div>
    </modal>

    <modal
      name="certificationModal"
      :resizable="true"
      :adaptive="true"
      :scrollable="true"
      width="90%"
      height="auto"
    >
      <div class="modal-box">
        <form>
          <div class="modal-ttl">
            <p>
              {{ $t("Two-factor authentication") }}
            </p>
            <div class="input-box">
              <input type="text" maxlength="1" />
              <input type="text" maxlength="1" />
              <input type="text" maxlength="1" />
              <input type="text" maxlength="1" />
              <input type="text" maxlength="1" />
              <input type="text" maxlength="1" />
            </div>
          </div>
          <div class="btn">
            <button v-on:click="hide2" type="button" class="link-over">
              {{ $t("Authenticate") }}
            </button>
          </div>
        </form>
      </div>
    </modal>

    <Footer title="WITHDRAWAL" />
  </div>
</template>
<style scoped></style>
<script>
import Header from "@/components/Header.vue";
import HeaderMenu from "@/components/HeaderMenu.vue";
import Sidebar from "@/components/Sidebar.vue";
import Footer from "@/components/Footer.vue";
export default {
  name: "Withdraw",
  components: {
    Header,
    HeaderMenu,
    Sidebar,
    Footer,
  },
  data: () => {
    return {
      title: "Withdraw",
      amountAp: 100,
      address: "",
    };
  },
  methods: {
    show: function () {
      this.$modal.show("sendModal");
    },
    hide: function () {
      this.$modal.hide("sendModal");
    },
    show2: function () {
      this.$modal.show("certificationModal");
    },
    hide2: function () {
      this.$modal.hide("certificationModal");
    },
    certificationAction: function () {
      this.$modal.hide("sendModal");
      this.$modal.show("certificationModal");
    },
  },
  computed: {
    hasAddress() {
      return this.address;
    },
  },
  mounted: function () {
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", vh + "px");

    var ua = navigator.userAgent.toLowerCase();
    var isiOS = ua.indexOf("iphone") > -1 || ua.indexOf("ipad") > -1;
    if (isiOS) {
      var viewport = document.querySelector('meta[name="viewport"]');
      if (viewport) {
        var viewportContent = viewport.getAttribute("content");
        viewport.setAttribute(
          "content",
          viewportContent + ", user-scalable=no"
        );
      }
    }
  },
};
</script>
